import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DataService } from './data.service';
import { Driver } from '../shared/driver.model';
import { MapObject } from '../shared/mapobject.model';

@Injectable({
    providedIn: 'root'
})

export class SelectService {
    private selectedDriverId = new BehaviorSubject<Driver>(null);
    private selectedDrivers = new BehaviorSubject<Driver[]>([]);
    private selectedAddress = new BehaviorSubject<Driver[]>([]);
    private selectedMapObject = new BehaviorSubject<MapObject>(null);
    private isSelected = new BehaviorSubject<boolean>(null);
    selectedDriverId$ = this.selectedDriverId.asObservable();
    selectedDrivers$ = this.selectedDrivers.asObservable();
    selectedAddress$ = this.selectedAddress.asObservable();
    selectedMapObject$ = this.selectedMapObject.asObservable();
    isSelected$ = this.isSelected.asObservable();

    constructor(private dataService: DataService) {

    }

    public getSelectedDriverId(driver: Driver) {
        this.selectedDriverId.next(driver);
    }

    public getSelectedDrivers(value: Driver[]) {
        this.selectedDrivers.next(value);
    }

    public getSelectedAddress(value: Driver[]) {
        this.selectedAddress.next(value);
    }

    public getSelectedMapObject(mapObject: MapObject) {
        this.selectedMapObject.next(mapObject);
    }

    public getSelectedState(state: boolean) {
        this.isSelected.next(state);
    }
}
